export const environment = {
    production: false,

    BASE_URL: "https://dev.api.team.wginb.com",
    LOGIN_ENDPOINT: "/wgteamlogin/login",
    LOGIN_SSO_ENDPOINT: "/wgteamlogin/ssologin",

    STATIC: '/wgteam/static',
    USER_DETAILS: '/wgteam/member/{email}',
    USER_PROFILE: '/wgteam/member/{email}/profile',

    EMPLOYEES: {
        ORGANIZATION_SUMMARY_ENDPOINT: "/wgteam/summary",
        MEMBER_LIST_ENDPOINT: "/wgteam/member/list",
        ADD_MEMBER_ENDPOINT: "/wgteam/member",
        UPDATE_MEMBER_ENDPOINT: "/wgteam/member/{email}",
        DELETE_MEMBER_ENDPOINT: "/wgteam/member/{email}",
    },

    TIME_OFF: {
        SUMMARY: '/wgteam/member/{email}/timeoff/summary',
        AUDIT: '/wgteam/member/{email}/timeoff/audit',
        MEMBER_PENDING_APPROVAL: '/wgteam/member/{email}/timeoff/member/pending/approval/list',
        CANCEL: '/wgteam/member/{email}/timeoff/{timeOffId}',
        APPLY_TIME_OFF: '/wgteam/member/{email}/timeoff',
        HISTORY: '/wgteam/member/{email}/timeoff/history'
    },

    APPROVALS: {
        MANAGER_PENDING_APPROVAL: '/wgteam/member/{email}/timeoff/manager/pending/approval/list',
        HISTORY: '/wgteam/member/{email}/timeoff/manager/approval/list',
        ACTION: '/wgteam/member/{email}/timeoff/{timeOffId}/approval/action',
        MANAGER_PENDING_APPROVAL_LIST: '/wgteam/approval/pending/manager/records'
    },

    ATTENDANCE: {
        UPLOAD: '/wgteam/attendance',
        MONTHLY: '/wgteam/attendance/{year}/{month}',
        MISSING: '/wgteam/attendance/missing',
        MISSING_SUMMARY: '/wgteam/attendance/missing/summary'
    },

    COMPOFF: {
        LIST: '/wgteam/compoff',
        ADD: '/wgteam/compoff',
        UPDATE: '/wgteam/compoff/{compoffId}',
        DELETE: '/wgteam/compoff/{compoffId}',
        APPROVE: '/wgteam/compoff/{compoffId}/approval',
        BATCH_APPROVE: '/wgteam/compoff/approval/batch',
        UPLOAD: '/wgteam/compoff/upload'
    },

    RESET_PASSWORD: "https://dev.portal.reset.wginb.com",

    EVENTS: {
        LIST_EVENTS: '/wgteam/event/list',
        GET_EVENT_SCORES: '/wgteam/event/{eventId}/scores',
        ADD_EVENT: '/wgteam/event',
        ADD_TEAM: '/wgteam/event/{eventId}/team',
        ADD_ACTIVITY: '/wgteam/event/{eventId}/activity',
        ADD_SCORE: '/wgteam/event/{eventId}/team/{teamId}/activity/{activityId}/score'
    },

    HOLIDAYS: {
        LIST_HOLIDAYS: '/wgteam/holidays/list'
    },

    SALARY: '/wgteam/member/{email}/salary',

    MSAL_CONFIG: {
        clientId: "f529d809-fdd8-4726-9659-2fc6c6f8f51d",
        authority: "https://login.microsoftonline.com/2563c132-88f5-466f-bbb2-e83153b3c808",
        redirectUri: "https://dev.portal.team.wginb.com",
        postLogoutRedirectUri: 'https://dev.portal.team.wginb.com'
    }
};
